import { ApiService } from "@/api";

export const getQuestionGroupIdsNotEmpty = () => {
  return ApiService.baseAction("question-group/ids/not_empty", {}, "GET");
};
